import type { TooltipOptions } from "highcharts";
import { renderToString } from "react-dom/server";

import { tooltipContainerConfig } from "@similarweb/pro-logic-components";
import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";

export const tooltipConfig: TooltipOptions = {
    outside: true,
    headerFormat: "",
    useHTML: true,
    ...tooltipContainerConfig().tooltip,
    pointFormatter() {
        return renderToString(
            <LegendWithOneLineBulletFlex
                text={this.name}
                value={`${this.y}%`}
                labelColor={this.color as string}
            />,
        );
    },
};
